import { IListUsersRequest } from "../../../model/security/request/list-users-request";
import { ICreateUserRequest } from "../../../model/security/request/create-user-request";
import { IUpdateUserRequest } from "../../../model/security/request/update-user-request";
import { IEnableDisableUserRequest } from "../../../model/security/request/enable-disable-user-request";
import { IUserListResponse } from "../../../model/security/response/user-list-response";
import { IUserDetailResponse } from "../../../model/security/response/user-detail-response";
import { IResetPasswordResponse } from "../../../model/security/response/reset-password-response";
import { PaginationResponse } from "../../../model/base/response/pagination-response";
import HttpClient from "../../services/http-client";
import ApplicationAppService from "../application-app-service";

const defaultPath = 'User';
let applicationData = ApplicationAppService.getApplicationData();
var baseUrl = applicationData.securityUrl;

const listUsers = async (params: IListUsersRequest): Promise<PaginationResponse<IUserListResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/`,
        params: params
    }).then((response) => Object.assign(new PaginationResponse<IUserListResponse>(), response.data));
};

const getUserById = async (id: number): Promise<IUserDetailResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/${id}`
    }).then((response) => Object.assign({} as IUserDetailResponse, response.data));
};

const createUser = async (params: ICreateUserRequest): Promise<IUserDetailResponse> => {
    return await HttpClient.executeRequest({
        method: 'post',
        baseURL: baseUrl,
        data: params,
        url: `/${defaultPath}/`
    }).then((response) => Object.assign({} as IUserDetailResponse, response.data));
};

const updateUser = async (params: IUpdateUserRequest): Promise<IUserDetailResponse> => {
    return await HttpClient.executeRequest({
        method: 'put',
        baseURL: baseUrl,
        data: params,
        url: `/${defaultPath}/${params.userId}`
    }).then((response) => Object.assign({} as IUserDetailResponse, response.data));
};

const enableDisableUser = async (params: IEnableDisableUserRequest): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'patch',
        baseURL: baseUrl,
        data: params,
        url: `/${defaultPath}/${params.userId}/status`
    });
};

const resetPassword = async (userId: number): Promise<IResetPasswordResponse> => {
    return await HttpClient.executeRequest({
        method: 'patch',
        baseURL: baseUrl,
        url: `/${defaultPath}/${userId}/password`
    }).then((response) => Object.assign({} as IResetPasswordResponse, response.data));
};

const UsersAppService = {
    listUsers,
    getUserById,
    createUser,
    updateUser,
    enableDisableUser,
    resetPassword
};

export default UsersAppService;
